import { render, staticRenderFns } from "./dynamicField.vue?vue&type=template&id=54b2da6a&"
import script from "./dynamicField.vue?vue&type=script&lang=ts&"
export * from "./dynamicField.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../wellness/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports